import { COOKIE_NAME_HAS_DISMISSED_PRIVACY_NOTICE } from '@core/js/constants';
import Cookies from '@core/js/services/cookies';

import { generate } from '@core/js/utils/componentUtils';
import { dDom } from '@core/js/utils/renderUtils';
import { createGAEvent } from '@core/js/utils/analyticsUtils';
import { dismissPrivacyNotice } from '@core/js/actions/privacyPreferencesActions';
import { handleUtagEvent } from '@core/js/actions/initialActions';

import template from 'privacy-notice.j2';

/**
 * Attach component events to DOM
 * @param {Object} store Redux store
 * @returns {undefined}
 */
export function attachEvents(store) {

    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-dismiss-privacy-notice'), () => {
        const { core } = store.getState();
        const privacyRestrictionRegion = _.get(core, 'privacyRestriction.region', '').toLowerCase();

        const gaEvent = createGAEvent(
            'PAGE_TYPE',
            'Privacy Banner',
            'Accepted'
        );

        Cookies.setCookie(`${COOKIE_NAME_HAS_DISMISSED_PRIVACY_NOTICE}_${privacyRestrictionRegion}`, 'true');
        store.dispatch(handleUtagEvent(gaEvent, 'link'));
        store.dispatch(dismissPrivacyNotice(true));
    });
}

/**
 * Bootstrap the component onto the page
 * @param {Object} store Redux store
 * @param {Object} overrides optional overridden component properties
 * @returns {Object} the generated component
 */
export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-privacy-notice',
        className: 'dom-privacy-notice',
        watch: ['core.privacyRestriction'],
        name: 'privacyNoticeComponent',
        attachEvents: attachEvents,
        renderType: dDom,
        template: template,
    };
    return generate(config, store, overrides);
}
